<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M674.1 646.6 545.2 297.5c-5.3-14.3-18.8-23-33.2-22.9-14.4-.1-27.9 8.6-33.2 22.9L389 541c-.1.2-.2.5-.3.7L350 646.6c-6.7 18.1 2.6 38.3 20.7 45 4 1.5 8.1 2.2 12.1 2.2 14.2 0 27.6-8.8 32.8-22.9l30.4-82.4h132l30.4 82.4c5.2 14.1 18.6 22.9 32.8 22.9 4 0 8.1-.7 12.1-2.2 18.2-6.8 27.5-26.9 20.8-45zM471.9 518.4 512 409.7l40.1 108.7h-80.2z" data-follow-fill="#231815" :fill="_fill" />
      <path
        d="M117.1 644.1c-14.2 0-26.8-9-31.4-22.4-.6-1.8-1.1-3.7-1.4-5.6C76.2 582.2 72 547.2 72 512c0-118 45.6-228.6 128.5-311.5C283.4 117.7 394 72.1 512 72.1c98.6 0 195.2 33.4 272 94l.1.1c17.2 14.3 31.4 27.1 43.9 39.7v-23.4c0-15.5 11.8-29.2 28.2-32.6l1.3-.3h3.4c15.5 0 29.2 11.8 32.6 28.2l.3 1.3v119.7c0 15.5-11.8 29.2-28.2 32.6l-1.3.3H744.6c-19.1 0-32.9-13.8-32.9-32.9 0-15.5 11.8-29.2 28.2-32.6l1.3-.3H794c-16.4-18.5-34.4-34.4-50.3-47.9-65.7-52.5-145.8-80.2-231.7-80.2-206.3 0-374.2 167.9-374.2 374.2 0 29.2 3.4 58.3 10.1 86.4 1.2 3 2 6.1 2.3 9.3.1 1 .1 2 .1 3.1 0 18.4-14.9 33.3-33.2 33.3zm395 308.2c-98.6 0-195.2-33.4-272-94l-.1-.1c-17.2-14.3-31.4-27.1-43.9-39.7v23.4c0 15.5-11.8 29.2-28.2 32.6l-1.3.3h-3.4c-15.5 0-29.2-11.8-32.6-28.2l-.3-1.3V725.6c0-15.5 11.8-29.2 28.2-32.6l1.3-.3h119.6c19.1 0 32.9 13.8 32.9 32.9 0 15.5-11.8 29.2-28.2 32.6l-1.3.3H230c16.4 18.5 34.4 34.4 50.3 47.9 65.6 52.4 145.7 80.1 231.7 80.1 206.3 0 374.2-167.9 374.2-374.2 0-29.2-3.4-58.3-10.1-86.4-1.2-3-2-6.1-2.3-9.3-.1-1-.1-2-.1-3.1 0-18.3 14.9-33.2 33.2-33.2 14.2 0 26.8 9 31.4 22.4.6 1.8 1.1 3.7 1.4 5.6 8.1 33.8 12.2 68.8 12.2 104 0 118-45.6 228.6-128.5 311.5-82.7 82.8-193.3 128.5-311.3 128.5z"
        data-follow-fill="#231815"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
